<div class="content">
  <canvas #lineChart></canvas>
</div>
